import { DrugToDrugInteractionsResultModel } from './drugToDrugInteractionsResultModel';
import { DrugToDiseaseInteractionsResultModel } from './drugToDiseaseInteractionsResultModel';
import { DrugToOtherParametersResultModel } from './drugToOtherParametersResultModel';

export class InteractionsResultModel {
  public drugToDrugInteractionsCount: number;
  public drugToDiseaseInteractionsCount: number;
  public drugToOtherParametersCount: number;
  public drugToDrugInteractionsResults: Array<DrugToDrugInteractionsResultModel>;
  public drugToDiseaseInteractionsResults: Array<DrugToDiseaseInteractionsResultModel>;
  public drugToOtherParametersResults: Array<DrugToOtherParametersResultModel>;
}